import React from 'react';
/**
 * @function ButtonContainer 
 * @param {STRING} className - Additional CSS class that we can pass to the button container.
 * @param {React.Component} children - React components that's being wrapped by the button container.
 * @returns {React.Component}
 * @example
 * <ButtonContainer className="some-class">
 *  <UIButton className="primary-button">Button Name</UIButton>
 * </ButtonContainer>
 */
export default function ButtonContainer(props) {
  const className = props.className ?? "";
  return (
    <div className={`${className} button-container flex-container flex-horizontal`}>
        {props.children}
    </div>
  );
}